import { render, staticRenderFns } from "./HistoryClass.vue?vue&type=template&id=9fecc6b0&"
import script from "./HistoryClass.vue?vue&type=script&lang=js&"
export * from "./HistoryClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports